import { useEffect } from "react";

const BASE_TITLE = "Montivex Supply Chain Solutions";

export default function Seo({ title, description, keywords }) {
  useEffect(() => {
    const fullTitle = title ? `${BASE_TITLE} — ${title}` : BASE_TITLE;
    document.title = fullTitle;

    const set = (key, content, attr = "name") => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    set("description", description);
    set("keywords", keywords);
    set("og:title", fullTitle, "property");
    set("og:description", description, "property");
    set("twitter:title", fullTitle);
    set("twitter:description", description);
  }, [title, description, keywords]);

  return null;
}
